import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "check-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M15.253 4.336a1 1 0 1 1 1.494 1.328l-8 9a1 1 0 0 1-1.454.043l-4-3.998a1 1 0 0 1 1.414-1.414l3.25 3.248 7.296-8.207z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
